import { User, UserDetail } from '../../entities/profile/profile.model';
import { UserDTO, UserDetailDTO } from './UserDTO';

export class UsersDTO {
    houseUsers: UserDTO[];

    static fromDto(usersDTO: UsersDTO): Map<string, User> {
        const users: Map<string, User> = new Map();
        usersDTO.houseUsers.forEach(user => {
            users.set(user.email, UserDTO.fromDto(user));
        });
        return users;
    }

    static fromDtoSingle(user: UserDetailDTO): UserDetail {
        return UserDetailDTO.fromDto(user);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/DTO/UsersDTO.ts